import axios from 'axios'
import Head from 'next/head'
import React, { useCallback, useState } from 'react'

import BlockUI from '@/components/common/BlockUI'
import ContactComplete from '@/components/parts/contact/ContactComplete'
import ContactConfirm from '@/components/parts/contact/ContactConfirm'
import ContactContainer, { ContactParams } from '@/components/parts/contact/ContactContainer'

const Contact: React.FC = () => {
  const [values, setValues] = useState<ContactParams>({
    otoiawasesyubetsu_atsougi: '',
    company: '',
    firstname: '',
    lastname: '',
    email: '',
    phone: '',
    syozaichi: '',
    toiawasenaiyou: '',
    identification_label: '法人',
  })
  const [formState, setFormState] = useState<string>('form')
  const [targetValue, setTargetValue] = useState('法人のお客様')
  const [blocking, setBlocking] = useState(false)

  const toConfirm = useCallback((values: ContactParams) => {
    setValues(values)
    setFormState('confirm')
    setTimeout(() => window.scroll(0, 0), 0)
  }, [])

  const backForm = useCallback(() => {
    setFormState('form')
  }, [])

  const toSubmit = useCallback(async () => {
    setBlocking(true)
    try {
      await axios.post('/api/sendMail', values)
      setBlocking(false)
      setFormState('complete')
      setTimeout(() => window.scroll(0, 0), 0)
    } catch (e) {
      setBlocking(false)
      window.alert((e as Error).message)
    }
  }, [values])
  return (
    <>
      <Head>
        <title>お問い合わせ | アット葬儀（@葬儀）</title>
      </Head>
      {blocking && <BlockUI />}
      {formState === 'form' && (
        <ContactContainer
          values={values}
          toConfirm={toConfirm}
          targetValue={targetValue}
          setTargetValue={setTargetValue}
        />
      )}
      {formState === 'confirm' && (
        <ContactConfirm
          values={values}
          back={backForm}
          submit={toSubmit}
          targetValue={targetValue}
        />
      )}
      {formState === 'complete' && <ContactComplete />}
    </>
  )
}
export default Contact
